/** Local hour (0-23) a business day starts, in the org's timezone. */
export const BUSINESS_DAY_START_HOUR = 9;

/** Local hour (0-23) a business day ends, in the org's timezone. */
export const BUSINESS_DAY_END_HOUR = 17;

/** Working hours in one business day. */
export const BUSINESS_HOURS_PER_DAY =
  BUSINESS_DAY_END_HOUR - BUSINESS_DAY_START_HOUR;
